import { render, staticRenderFns } from "./ExchangeSettings.vue?vue&type=template&id=6456603b&scoped=true&lang=pug"
import script from "./ExchangeSettings.vue?vue&type=script&lang=js"
export * from "./ExchangeSettings.vue?vue&type=script&lang=js"
import style0 from "./ExchangeSettings.vue?vue&type=style&index=0&id=6456603b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6456603b",
  null
  
)

export default component.exports